module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.3112/img/storefront-header-blobs.svg"